import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth, roleHome } from "@/context/AuthContext";
import { Loader2, AlertCircle } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const clinicId = localStorage.getItem("pending_clinic_id") || "";
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId, "X-Clinic-ID": clinicId },
        });
        localStorage.removeItem("pending_clinic_id");
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(roleHome(data.user), { replace: true });
      } catch (e) {
        const detail = e.response?.data?.detail;
        setError(typeof detail === "string" ? detail : "We couldn't complete Google sign-in. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 3000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-white px-6 text-center">
      {error ? (
        <div className="flex items-center gap-2 text-red-600">
          <AlertCircle className="h-5 w-5" /> <span>{error}</span>
        </div>
      ) : (
        <>
          <Loader2 className="h-8 w-8 animate-spin text-[#0F52BA]" />
          <p className="text-slate-500">Signing you in…</p>
        </>
      )}
    </div>
  );
}
